import { observable, computed } from 'mobx';
import BaseModalStore from '@src/components/modal-container/base-modal-store';
import { noop } from '@src/utils/common-util';
import { autobind } from 'core-decorators';
import { SHARE_METHOD_CONFIG } from './config';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import { aLink } from '@src/utils/common-util';
const lang = getLanguageByPath();

class AppointmentSuccessModalStore extends BaseModalStore {
  @observable expandVideoUrl = '';
  @observable closeCallback = noop;

  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  @observable email = '';

  @computed
  get itemList() {
    return SHARE_METHOD_CONFIG.filter(item => item.applyLanguages.includes(lang))
      .sort((a, b) => a.order[lang] - b.order[lang])
      .map(item => ({
        name: item.name,
        link: item.linkLocales[lang],
        img: item.img,
        onClick: item.onClick
      }));
  }

  /**
   * 点击跳转
   * @param url
   */
  @autobind
  onRedirectLink(url) {
    if (url) {
      aLink(url);
    }
  }

  /**
   * 点击关闭弹窗
   * 重写关闭事件, 补充了弹窗特定的关闭回调
   */
  onClickClose = () => {
    this.isOpen = false;
    this.isActive = false;
    this.closeCallback();
    this.clearStyle();
    this.onClose();
  };

  use() {
    // super.use();
  }
}

export default AppointmentSuccessModalStore;
